import { MainList } from "components";
import { Main } from "layouts";
import { Button } from "expano-components";
import { ReactComponent as StickerIcon } from "icons/sticker.svg";

import { sort, filters } from "./const/data";

const BrandLabelsList = ({ history }) => {
  return (
    <Main
      page={{
        name: "Etykiety markowe",
        icon: <StickerIcon />,
        breadcrumbs: [{ name: "Etykiety markowe" }],
        buttons: (
          <Button
            type="add"
            text="Dodaj etykietę markową"
            onClick={() => history.push("/brand-labels/new")}
          />
        ),
      }}
    >
      <MainList
        query_key="brand_labels"
        api_path="/brand_labels"
        title="Lista etykiet markowych"
        sort_column="id"
        sort_direction="desc"
        sort={sort}
        filters={filters}
        handleNavigate={(item, event) =>
          event?.button === 1
            ? window.open(`/brand-labels/${item.id}`, "_blank")
            : history.push(`/brand-labels/${item.id}`)
        }
        renderItem={({ id, name, image_thumb_url, image_url }) => (
          <>
            <td>{id}</td>
            <td>
              {(image_thumb_url || image_url) && (
                <img
                  src={image_thumb_url || image_url}
                  alt={name}
                  style={{ maxWidth: 72, maxHeight: 48 }}
                />
              )}
            </td>
            <td>
              <strong>{name}</strong>
            </td>
          </>
        )}
      />
    </Main>
  );
};

export default BrandLabelsList;
